<!--缩略图展示 Sag 2020-04-16-->
<template>
  <div class="its-data-grid">
    <div class="its-header">
      <div data-v-095eeb19="" class="el-table el-table--fit el-table--enable-row-hover el-table--enable-row-transition" style="width: 100%;">
      <div class="hidden-columns">
        <div data-v-095eeb19=""></div>
        <div data-v-095eeb19=""></div>
        <div data-v-095eeb19=""></div>
        <div data-v-095eeb19=""></div>
        <div data-v-095eeb19=""></div>
      </div>
      <div class="el-table__header-wrapper">
        <table cellspacing="0" cellpadding="0" border="0" class="el-table__header" style="width: 1200px;">
        <colgroup>
          <col name="el-table_1_column_1" width="60" />
          <col name="el-table_1_column_2" width="600" />
          <col name="el-table_1_column_3" width="120" />
          <col name="el-table_1_column_4" width="200" />
          <col name="el-table_1_column_5" width="220" />
          <col name="gutter" width="0" />
        </colgroup>
        <thead class="has-gutter">
          <tr class="">
            <th colspan="10" rowspan="1" class="el-table_1_column_1   el-table-column--selection  is-leaf">
              <div class="cell">
                <el-checkbox :indeterminate="isIndeterminate" v-model="mutilChecked" @change="checkedAll">全选</el-checkbox>
                <!-- <label class="el-checkbox"><span class="el-checkbox__input"><span class="el-checkbox__inner"></span><input type="checkbox" aria-hidden="false" class="el-checkbox__original" value="" /></span></label> -->
              </div>
            </th>
          </tr>
        </thead>
        </table>
      </div>
      <div class="el-table__column-resize-proxy" style="display: none;"></div>
      </div>
    </div>
    <div class="its-data-grid-items">
      <div-no-data v-if="tableData.length==0" class="no-data">
        <p class="empty">暂无数据</p>
      </div-no-data>
      <template v-else>
        <div class="its-data-grid-item" v-for="(item, i) in tableData" :key="i" :class="{'active':checkedList.indexOf(item.id)>=0}">
          <p class="file-check its-icon its-icon-xuanzhong" @click="checkItem(item)"></p>
          <a :title="item.fileName" @click="toDetail(item)">
            <div class="type-icon sm " :class="[item.folder?'file':item.fileSuffix]"></div>
            <span>{{item.fileName}}</span>
          </a>
        </div>
      </template>
    </div>
    <preview v-if="showPreview" :previewParams="previewParams" :previewRaw="previewRaw" :father-action="previewAction"></preview>
  </div>
</template>
<script>
import DivNoData from '../../../components/DivNoData'
import Preview from './Preview'
export default {
  name: 'DataGrid',
  components: {
    DivNoData,
    Preview
  },
  props: {
    checkedItems: {
      type: Array,
      default: function () {
        return []
      }
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    fatherAction: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      showPreview: false,
      previewParams: {id: '699', service: 'DOCUMENT', full: true, provider: 'I_CLASS'},
      previewRaw: {mime: 'doc', title: 'sdsd.doc'},
      isIndeterminate: true,
      mutilChecked: false,
      checkedList: []
    }
  },
  mounted () {
    if(this.checkedItems.length > 0) {
      this.checkedList = JSON.parse(JSON.stringify(this.checkedItems))
    } else {
      this.checkedList = []
    }
    let checkedCount = this.checkedList.length
    this.isIndeterminate = checkedCount > 0 && checkedCount < this.tableData.length
  },
  methods: {
    checkItem: function (item) {
      let index = this.checkedList.indexOf(item.id)
      if(index >= 0) {
        this.checkedList.splice(index, 1)
      }else {
        this.checkedList.push(item.id)
      }
      let checkedCount = this.checkedList.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.tableData.length;
      console.log(this.checkedList)
      this.$emit('selectedItems', this.checkedList)
    },
    checkedAll: function () {
      if (this.mutilChecked) {
        this.checkedList = []
        // 全选
        this.tableData.forEach((it)=>{
          this.checkedList.push(it.id)
        })
      } else {
        //取消全选
        this.checkedList = []
      }
      this.isIndeterminate = false
      this.$emit('selectedItems', this.checkedList)
    },
    toDetail: function (item) {
      console.log(item)
      if(!item.folder) {
        //文件预览
        if (item.sourceId === 0) {
          this.$message.warning('资料正在同步中，请稍后')
          return
        }
        let type = item.fileSuffix
        if (type == 'rar' || type == 'other') {
          console.log('不支持预览')
          this.$message.warning('该文件不支持预览')
          return
        } else {
          this.previewParams = {
            id: item.sourceId,
            service: 'DOCUMENT',
            full: true,
            provider: item.provider
          }
          this.previewRaw = {
            mime: type,
            title: item.fileName
          }
        }
        this.showPreview = true
      }
      if(this.fatherAction) {
        this.fatherAction({type:'name-click', item: item})
      }
    },
    clearSelections: function () {
      this.checkedList = []
      this.isIndeterminate = false
      this.$emit('selectedItems', this.checkedList)
    },
    previewAction: function (data) {
      if (data.type === 'close') {
        this.showPreview = false
      }
    }
  },
  watch: {
    checkedList: function () {
      if(this.checkedList.length === this.tableData.length && this.tableData.length > 0) {
        this.mutilChecked = true
      } else {
        this.mutilChecked = false
      }
    },
    showPreview: function () {
      this.$emit('show-preview', this.showPreview)
    }
  }
}
</script>
<style scoped>
.its-data-grid-items::after {
  clear: both;
  content: '';
  display: block;
}
.its-data-grid-items {
  padding: 10px 20px 20px 20px;
}
.its-data-grid-item{
    width: 118px;
    height:128px;
    float:left;
    margin: 5px 10px 5px 0;
    text-align: center;
    vertical-align: middle;
    border: 1px dashed #ffffff;
}
.its-data-grid-item a {
  cursor: pointer;
}
.its-data-grid-item div{
    margin: 35px 26px 15px 0px;
    text-align: center;
}

.its-data-grid-item:hover{
    background-color: #f2f2f2;
    border: 1px dashed #f2f2f2;
}

.its-data-grid-item.active {
    width: 118px;
    height:128px;
    border-color: #5591fe;
}

.file-check {
    width: 19px;
    height: 19px;
    float: left;
    margin-left: 5px;
    margin-top: 5px;
    color:white;
}

.its-data-grid-item .file-title {
    float: left;
    text-align: center;
    width: 110px;
    padding: 0 4px;
}

.its-data-grid-item .file {
    margin-bottom: 24px;
}

.its-data-grid-item:hover .file-check{
    color:#c3d5f6;
}

.its-data-grid-item.active .file-check{
    color:#5591fe;
}

.its-data-grid-item a span {
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    width:110px;
    float:left;
    padding:0 5px;
    color: #333333;
}
.no-data {
  margin-bottom: 10px;
}
</style>
